export default {"src":"/oferta/_next/static/media/weight-loss.9615ee3d.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};